import { request } from '@umijs/max';

/** 获取当前的用户 GET */
export async function currentUser(options?: { [key: string]: any }) {
    return request<{
        data: Account.CurrentUser;
    }>('/api/v1/account/current', {
        method: 'GET',
        ...(options || {}),
    });
}